import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Icon from 'common/components/Icon';
import { TextField } from '../../form/field';

const EditableEmailField = ({
    isPartner,
    required,
    instanceTheseis,
    disabledPersonalEmail,
    disabledPartnerPersonalEmail,
    onClickEmailInput,
}) => {
    const renderEditableField = ({
        name,
        title,
        disabled,
        onEdit,
    }) => (
        <Fragment>
            {instanceTheseis && disabled ? (
                <div style={{ position: 'relative' }}>
                    <TextField
                        title={title}
                        placeholder="adresse@email.com"
                        required={required}
                        name={name}
                        className="form-group-grid disabledEmail"
                        disabled
                    />
                    <span
                        role="button"
                        tabIndex={0}
                        aria-label="Modifier l'email personnel"
                        className="edit-email-icon"
                        onClick={onEdit}
                        onKeyDown={(e) => {
                            if ('Enter' === e.key || ' ' === e.key) {
                                onEdit(e);
                            }
                        }}
                    >
                        <Icon icon="pencil" />
                    </span>
                </div>
            ) : (
                <TextField
                    title={title}
                    placeholder="adresse@email.com"
                    required={required}
                    name={name}
                />
            )}
        </Fragment>
    );

    return (
        <Fragment>
            {renderEditableField({
                name: isPartner ? 'partnerPersonalEmail' : 'personalEmail',
                title: isPartner ? 'Email du conjoint' : 'Email',
                disabled: isPartner ? disabledPartnerPersonalEmail : disabledPersonalEmail,
                onEdit: (e) => onClickEmailInput(e, isPartner),
            })}
        </Fragment>
    );
};

EditableEmailField.propTypes = {
    isPartner: PropTypes.bool,
    required: PropTypes.bool,
    instanceTheseis: PropTypes.bool,
    disabledPersonalEmail: PropTypes.bool,
    disabledPartnerPersonalEmail: PropTypes.bool,
    onClickEmailInput: PropTypes.func.isRequired,
};

export default EditableEmailField;
